import { createAction, props } from '@ngrx/store';

export const setTotalValuesCoverageAction = createAction(
  '[TOTALVALUESCOVERAGE] Set TOTALVALUESCOVERAGE',
  props<{ TotalValues: any }>()
);